import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
type CardTitleProps = {
  title: string;
  /** h2 where the card is a top-level section of the page, like the details page's vault. */
  as?: 'h2' | 'h5';
  count?: number;
  /** A short status at the strip's right end, such as a node's outcome. */
  rightContent?: ReactNode;
};

/** A `Card.Root`'s name in the top-left corner of its tray, as compact as the report builder's section cards. */
const CardTitle = t0 => {
  const $ = _c(11);
  const {
    title,
    as: t1,
    count,
    rightContent
  } = t0;
  const Heading = t1 === undefined ? "h5" : t1;
  let t2;
  if ($[0] !== title) {
    t2 = <span className="truncate pointer-coarse:whitespace-normal" title={title}>{title}</span>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== count) {
    t3 = count !== undefined && <>{" "}<span className="text-body-3 tabular-nums">({count})</span></>;
    $[2] = count;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== Heading || $[5] !== t2 || $[6] !== t3) {
    t4 = <Heading className="flex min-w-0 items-center gap-1.5 text-label-3 text-tertiary">{t2}{t3}</Heading>;
    $[4] = Heading;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== rightContent || $[9] !== t4) {
    t5 = <div className="mb-1 flex min-h-6 items-center justify-between gap-3 px-2">{t4}{rightContent}</div>;
    $[8] = rightContent;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default CardTitle;